import { footerLinks } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 px-4 pt-12 pb-8 md:px-8 md:pt-16">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr] md:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50">
                <i className="ri-movie-2-line text-xl text-primary-800"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">韩剧TV</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-50/75">
              本站围绕韩剧TV 的下载安装、缓存视频、离线观看、安卓版下载、苹果版下载与下载到手机，整理成一份可独立翻阅的实用指南。内容用于说明常见操作流程，具体界面与功能请以应用内实际显示为准。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 sm:grid-cols-2">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-50/75 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">阅读提示</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-50/75">
              <li className="flex gap-2.5">
                <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center pt-0.5">
                  <i className="ri-shield-check-line text-base text-accent-300"></i>
                </span>
                请通过可信渠道获取安装包，注意设备安全。
              </li>
              <li className="flex gap-2.5">
                <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center pt-0.5">
                  <i className="ri-database-2-line text-base text-accent-300"></i>
                </span>
                缓存会占用手机空间，建议定期清理已看内容。
              </li>
              <li className="flex gap-2.5">
                <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center pt-0.5">
                  <i className="ri-time-line text-base text-accent-300"></i>
                </span>
                页面内容随应用版本更新可能变化，以实际为准。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-50/60">
            © 2026 韩剧TV 下载与离线观看指南 · 内容仅供操作参考
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50/75 transition-colors hover:text-accent-300"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-up-line text-base"></i>
            </span>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}